import { useNavigate } from '@tanstack/react-router'
import { openEvaluationsTab } from 'features/evaluations/utils/openEvaluationsTab'
import { useSelectedOrgAndSiteInterface } from 'features/orgAndSiteSourceOfTruth/orgSiteInterface'
import { useOptionalWorkspaceTabsActions } from 'features/workspaceTabs/contexts/WorkspaceTabsContext'
import { useCallback } from 'react'

export function useOpenEvaluationsTab(): () => void {
  const navigate = useNavigate()
  const { getOrganizationId, getSiteId } = useSelectedOrgAndSiteInterface()
  const openDestinationTab =
    useOptionalWorkspaceTabsActions()?.openDestinationTab

  return useCallback(() => {
    openEvaluationsTab({
      navigate,
      openDestinationTab,
      organizationId: getOrganizationId(),
      siteId: getSiteId(),
    })
  }, [getOrganizationId, getSiteId, navigate, openDestinationTab])
}
